
import React, { Component } from 'react';
import $ from 'jquery'



export default class DocumentationComponent extends Component {

    constructor() {
        super();
        this.state = { markdown: '' };
    }

    render() {
        return (
            <div>
                Hello
            </div>
        )
    }
}
